<div class="steps-wrapper" [style]="style">
    <div class="steps-container">
        <p-steps [model]="items" [readonly]="false" [activeIndex]="activeIndex" (activeIndexChange)="stepActiveIndexChange($event)"></p-steps>
    </div>
</div>